import { AlertTriangle, X } from 'lucide-react-native';
import { useState } from 'react';
import { Pressable } from 'react-native';
import { AnimatedCard } from '../../../components/animations';
import { Box } from '../../../components/primitives/Box';
import { HStack } from '../../../components/primitives/Stack';
import { Text } from '../../../components/primitives/Text';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';

interface AlertBannerProps {
  message: string;
  delay?: number;
}

export function AlertBanner({ message, delay = 0 }: Readonly<AlertBannerProps>) {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <AnimatedCard delay={delay}>
      <Box
        backgroundColor={colors.status.warning.bg}
        borderWidth={1}
        borderColor={colors.status.warning.main}
        padding="lg"
        accessibilityRole="alert"
        accessibilityLiveRegion="polite"
        style={{
          borderRadius: 18,
        }}
      >
        <HStack spacing="md" align="center" justify="between">
          <HStack spacing="md" align="center" style={{ flex: 1 }}>
            <AlertTriangle size={18} color={colors.status.warning.main} strokeWidth={2.5} />
            <Text
              variant="body"
              color={colors.status.warning.light}
              style={{ flex: 1, fontWeight: '500' }}
            >
              {message}
            </Text>
          </HStack>
          <Pressable
            onPress={() => setDismissed(true)}
            hitSlop={8}
            accessibilityLabel={t('analytics.alert.dismiss')}
            accessibilityRole="button"
          >
            <X size={16} color={colors.status.warning.light} />
          </Pressable>
        </HStack>
      </Box>
    </AnimatedCard>
  );
}
